"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _events = _interopRequireDefault(require("../events"));
var _jsonrpc = require("../jsonrpc");
var _misc = _interopRequireDefault(require("../../helpers/misc"));
var _debug = _interopRequireDefault(require("debug"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const debug = (0, _debug.default)('MEWconnectWeb3');
var _default = async (_ref, res, next) => {
  let payload = _ref.payload,
    eventHub = _ref.eventHub;
  if (payload.method !== 'eth_sign') return next();
  const msg = payload.params[1];
  eventHub.emit(_events.default.SHOW_MSG_CONFIRM_MODAL, msg, _response => {
    if (_response.reject) {
      debug('USER DECLINED SIGN MESSAGE');
      res((0, _jsonrpc.toError)(payload.id, 'User Rejected Request', 4001));
      return;
    }
    _response = _misc.default.sanitizeHex(_response.toString('hex'));
    debug('sign result', _response);
    res(null, (0, _jsonrpc.toPayload)(payload.id, _response));
  });
};
exports.default = _default;